import type { FC } from 'react';
import { TooltipedIcon } from '@components/TooltipedIcon';
import { mdiPlusCircle } from '@mdi/js';
import { getDataTestId } from '@root/src/utils/element-testid-selectors';

import { addIconClasses } from '../classes';

interface AddBlockIconProps {
  onCreate: () => void;
}

export const AddBlockIcon: FC<AddBlockIconProps> = ({ onCreate }) => (
  <div className={addIconClasses} data-testid={getDataTestId('block.addNew')} onClick={onCreate} aria-hidden="true">
    <div className="border-primary-500 grow border-t"></div>
    <span className="text-primary-500 shrink pointer-coarse:pointer-events-auto pointer-coarse:flex pointer-coarse:size-11 pointer-coarse:items-center pointer-coarse:justify-center">
      <TooltipedIcon path={mdiPlusCircle} size={1} content="Add block" placement="top" />
    </span>
    <div className="border-primary-500 grow border-t"></div>
  </div>
);
